import CircularProgress from '@mui/material/CircularProgress';

/**
 * @deprecated use CircularProgress from atoms/CircularProgress instead
 */
const Loader = () => (
  <div className="material-loader-wrapper">
    <CircularProgress className="material-spinner" />
  </div>
);

export default Loader;
